import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import QATags from '../../../../constants/QATags';

import RowItemCustomBadge from './RowItemCustomBadge';
import RowItemEllipsis from './RowItemEllipsis';
import RowItemRightColumnChild from './RowItemRightColumnChild';
import RowItemRightColumnPlayButton from './RowItemRightColumnPlayButton';
import RowItemShuffleBadge from './RowItemShuffleBadge';
import RowItemSmallRowCollectedBadge from './RowItemSmallRowCollectedBadge';
import RowItemStandardBadges from './RowItemStandardBadges';

import './RowItemRightColumn.scss';

class RowItemRightColumn extends React.PureComponent {
  static propTypes = {
    isInteractive: PropTypes.bool,
    isFullRowLink: PropTypes.bool,
    isRowExtraLarge: PropTypes.bool,
    canShuffle: PropTypes.bool,
    sourceCardMenuItems: PropTypes.array,
    // Themes
    useDarkTheme: PropTypes.bool,
    useLightTheme: PropTypes.bool,
    // RowItemStandardBadges
    shouldHideBadges: PropTypes.bool,
    isRadioOnly: PropTypes.bool,
    isUnavailable: PropTypes.bool,
    isExplicit: PropTypes.bool,
    isClean: PropTypes.bool,
    // RowItemSmallRowCollectedBadge
    isCollected: PropTypes.bool,
    isRowSmall: PropTypes.bool,
    // RowItemCustomBadge specific
    isCustomBadge: PropTypes.string, // Something is wrong here
    isBadgeFilled: PropTypes.bool,
    // RowItemRightColumnChild/RowItemRightColumnPlayButton
    isRowHovered: PropTypes.bool,
    onRightColChildClick: PropTypes.func,
    isRightColPersistent: PropTypes.bool,
    rightColChild: PropTypes.node,
    rightColChildHover: PropTypes.node,
    qaRightColChild: PropTypes.oneOf(values(QATags)),
    rightColMainText: PropTypes.node,
    rightColOnFocus: PropTypes.func,
    rightColOnBlur: PropTypes.func,
    onlyShowRightColPlay: PropTypes.bool,
    playButtonOnclick: PropTypes.func,
    // RowItemEllipsis
    enableSourceCardMenu: PropTypes.bool,
    sourceCardToggleCallback: PropTypes.func,
    qaEllipsis: PropTypes.oneOf(values(QATags)),
    isClickableRow: PropTypes.bool,
    // RowItemShuffleBadge Specific
    isShuffleDisabled: PropTypes.bool,
    shuffleOnclick: PropTypes.func,
    shuffleOnclickIfDisabled: PropTypes.func,
  };

  render = () => {
    return (
      <div className='RowItemRightColumn'>
        <RowItemStandardBadges
          isInteractive={this.props.isInteractive}
          useDarkTheme={this.props.useDarkTheme}
          useLightTheme={this.props.useLightTheme}
          shouldHideBadges={this.props.shouldHideBadges}
          isRadioOnly={this.props.isRadioOnly}
          isUnavailable={this.props.isUnavailable}
          isExplicit={this.props.isExplicit}
          isClean={this.props.isClean}
          isRowExtraLarge={this.props.isRowExtraLarge}
          isFullRowLink={this.props.isFullRowLink}
        />

        <RowItemSmallRowCollectedBadge
          isRowSmall={this.props.isRowSmall}
          isCollected={this.props.isCollected}
          isInteractive={this.props.isInteractive}
          isRowExtraLarge={this.props.isRowExtraLarge}
          isFullRowLink={this.props.isFullRowLink}
        />

        <RowItemCustomBadge
          isInteractive={this.props.isInteractive}
          useDarkTheme={this.props.useDarkTheme}
          useLightTheme={this.props.useLightTheme}
          isCustomBadge={this.props.isCustomBadge}
          isFilled={this.props.isBadgeFilled}
          isFullRowLink={this.props.isFullRowLink}
        />

        <RowItemRightColumnChild
          sourceCardMenuItems={this.props.sourceCardMenuItems}
          isInteractive={this.props.isInteractive}
          isRightColPersistent={this.props.isRightColPersistent}
          rightColChild={this.props.rightColChild}
          qaRightColChild={this.props.qaRightColChild}
          onClick={this.props.onRightColChildClick}
          rightColChildHover={this.props.rightColChildHover}
          mainText={this.props.rightColMainText}
          onFocus={this.props.rightColOnFocus}
          onBlur={this.props.rightColOnBlur}
          useDarkTheme={this.props.useDarkTheme}
          isRowHovered={this.props.isRowHovered}
        />

        <RowItemRightColumnPlayButton
          onlyShowRightColPlay={this.props.onlyShowRightColPlay}
          onClick={this.props.playButtonOnclick}
          qaTag={this.props.qaRightColChild}
        />

        <RowItemEllipsis
          enableSourceCardMenu={this.props.enableSourceCardMenu}
          useDarkTheme={this.props.useDarkTheme}
          sourceCardMenuItems={this.props.sourceCardMenuItems}
          sourceCardToggleCallback={this.sourceCardToggleCallback}
          triggerHidden={!this.props.isInteractive}
          qaEllipsis={this.props.qaEllipsis}
          onShuffle={this.props.canShuffle}
          isInteractive={this.props.isInteractive}
          isClickableRow={this.props.isClickableRow}
        />

        <RowItemShuffleBadge
          canShuffle={this.props.canShuffle}
          isShuffleDisabled={this.props.isShuffleDisabled}
          shuffleOnclickIfDisabled={this.props.shuffleOnclickIfDisabled}
          shuffleOnclick={this.props.shuffleOnclick}
        />
      </div>
    );
  };
}

export default RowItemRightColumn;
